import { Component, NgZone, OnInit, ChangeDetectionStrategy } from '@angular/core';
// import { SignalRService } from 'src/app/services/signal-r.service';
import { SignalRService } from '../../services/signal-r.service';
import { Message } from '../../models/Message';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../services//auth.service';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatComponent implements OnInit {

  txtMessage = '';
  message = new Message();
  messages = new Array<Message>();
  uniqueID = new Date().getTime().toString();

  componentDestroyed$: Subject<boolean> = new Subject();


  constructor(public authService: AuthService, public signalRService: SignalRService, private _ngZone: NgZone) { }

  ngOnInit(): void {
    if (this.authService.displayName) {
      this.subscribeToEvents();
      this.signalRService.startConnection();
    }
  }

  sendMessage(): void {
    if (this.txtMessage) {
      this.message = new Message();
      this.message.clientuniqueid = this.uniqueID;
      this.message.type = 'sent';
      this.message.message = this.txtMessage;
      this.message.date = new Date();
      this.message.displayName = this.authService.displayName;
      this.messages.push(this.message);
      this.signalRService.sendMessage(this.message);
      this.txtMessage = '';
    }
  }

  private subscribeToEvents(): void {
    this.signalRService.connectionEstablished
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((flag: Boolean) => {
        this._ngZone.run(() => {
          if (flag) {
            console.log('ChatComponent - connectionEstablished: ' + flag);
          }
        });
      });

    this.signalRService.messageReceived
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((message: Message) => {
        this._ngZone.run(() => {
          if (message.clientuniqueid !== this.uniqueID) {
            message.type = 'received';
            this.messages.push(message);
          }
        });
      });

    this.signalRService.carArrivedParking
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'carArrivedParking: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
    this.signalRService.pickedUpFromParking
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'pickedUpFromParking: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
    this.signalRService.droppedAtAirport
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'droppedAtAirport: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
    this.signalRService.pickedUpFromAirport
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'pickedUpFromAirport: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
    this.signalRService.droppedAtParking
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'droppedAtParking: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
    this.signalRService.carLeftParking
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((reservationId: number) => {
        this._ngZone.run(() => {
          const recievedActionMessage = new Message();
          recievedActionMessage.clientuniqueid = this.uniqueID;
          recievedActionMessage.type = 'signalr';
          recievedActionMessage.message = 'carLeftParking: ' + reservationId;
          recievedActionMessage.date = new Date();
          this.messages.push(recievedActionMessage);
        });
      });
  }

}
